import { useTranslation } from "react-i18next";
import { PayrollCounter } from "./PayrollCounter";
import { PayrollKpis } from "./PayrollKpis";
import { PayrollTotals } from "./PayrollTotals";
import { MonthSlipsCard } from "./MonthSlipsCard";

// لوحة الرواتب: العدّاد اليومي للفترة المحاسبية + بطاقات الإجماليات + كشف الموظفين.
export const PayrollDashboard = ({ run, progress, busy, onReload, onFinalize, filters }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-6" data-testid="payroll-dashboard">
      <PayrollCounter info={progress} busy={busy} onReload={onReload} />
      {run ? (
        <>
          <PayrollKpis run={run} />
          <PayrollTotals run={run} busy={busy} onFinalize={onFinalize} />
          <MonthSlipsCard filters={filters} />
        </>
      ) : (
        <p className="rounded-3xl bg-background p-6 text-center text-sm font-bold text-muted-foreground shadow-neu-in"
           data-testid="payroll-pick-hint">
          {t("payrollFilters.pickFirst")}
        </p>
      )}
    </div>
  );
};
